module.exports = __webpack_public_path__ + "img/Amelia-Solum.6cadb3fd.jpg";